const defaultLocale = require('../config').defaultLocale;

// Add more locales here to have multiple locale config
module.exports = {
  langs: [defaultLocale],
  defaultLangKey: defaultLocale,
  langKey: {
    [defaultLocale]: defaultLocale,
  },
};
